<div class="container p-3">
    <div class="row">
        <div class="col position-relative">
            <div style="position: absolute; top: 0px; right: 15px;">
                <button class="btn btn-primary" (click)="refreshChallenges()">
                    <i class="fas fa-sync-alt"></i> Refresh
                </button>
            </div>
            <h3 (click)="newChallengeVisible = !newChallengeVisible" style="cursor: pointer;">
                Upload a new challenge
                <span *ngIf="!newChallengeVisible">
                    <i class="fas fa-caret-right align-text-bottom"></i>
                </span>
                <span *ngIf="newChallengeVisible">
                    <i class="fas fa-caret-down align-text-bottom"></i>
                </span>
            </h3>
            <div class="background-hover" [hidden]="!newChallengeVisible" [formGroup]="newChallengeFormGroup">
                <div class="row">
                    <div class="col-8">
                        <div class="row">
                            <div class="col-6">
                                <div class="mb-3">
                                    <label for="newChallengeNameInput">Name</label>
                                    <input type="text" class="form-control" id="newChallengeNameInput" placeholder="10 KM, 10000 STEPS, ..." formControlName="newChallengeNameInput">
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label for="newChallengeStartInput">Start</label>
                                    <input type="text" class="form-control" id="newChallengeStartInput" formControlName="newChallengeStartInput" placeholder="yyyy-MM-dd">
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label for="newChallengeEndInput">End</label>
                                    <input type="text" class="form-control" id="newChallengeEndInput" formControlName="newChallengeEndInput" placeholder="yyyy-MM-dd">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="mb-3">
                                    <label for="newChallengeTargetInput">Target</label>
                                    <input type="number" min="0" max="100000" class="form-control" id="newChallengeTargetInput" formControlName="newChallengeTargetInput" placeholder="1000, 2000, ...">
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label for="newChallengeTypeSelect">Type</label>
                                    <select class="form-select" id="newChallengeTypeSelect" formControlName="newChallengeTypeSelect">
                                        <option value="CAL">Calories (calories)</option>
                                        <option value="DISTANCE">Distance (meters)</option>
                                        <option value="DURATION">Duration (seconds)</option>
                                        <option value="STEPS">Steps (steps)</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label for="newChallengeOrderBySelect">RankBy</label>
                                    <select class="form-select" id="newChallengeOrderBySelect" formControlName="newChallengeOrderBySelect">
                                        <option value="CAL">Calories (calories)</option>
                                        <option value="DISTANCE">Distance (meters)</option>
                                        <option value="DURATION">Duration (seconds)</option>
                                        <option value="STEPS">Steps (steps)</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col">
                                <div class="mb-3">
                                    <label for="newChallengeLimitInput">LimitToBeRanked</label>
                                    <input type="number" min="0" max="100000" class="form-control" id="newChallengeLimitInput" formControlName="newChallengeLimitInput" placeholder="1000, 2000, ...">
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <button class="btn btn-sm btn-primary" [disabled]="getNewChallengeDetailFormArray().controls.length >= 5" (click)="addChallengeDetail()">
                                <i class="fas fa-plus-circle"></i> Add description
                            </button>
                        </div>
                        <div formArrayName="newChallengeDetailFormArray" *ngFor="let detailControlGroup of getNewChallengeDetailFormArray().controls; let i = index;">
                            <div [formGroupName]="i">
                                <div class="row">
                                    <div class="col-3">
                                        <div class="mb-3">
                                            <input type="text" class="form-control" placeholder="Locale (en, fr, ...)" formControlName="newChallengeDetailLocaleInput">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="float-end">
                                            <button class="btn btn-sm btn-danger" (click)="removeChallengeDetail(i)">
                                                <i class="fas fa-times"></i> Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <textarea type="text" class="form-control" placeholder="Description..." formControlName="newChallengeDetailDetailnput"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="mb-3">
                            <label>Image</label>
                            <div>
                                <input type="file" accept="image/*" class="form-control" id="newChallengeMiniInput" (change)="newChallengeMiniInputChange($event)" formControlName="newChallengeMiniInput">
                            </div>
                        </div>
                        <!--div class="mb-3">
                            <label>Image (banner size)</label>
                            <div>
                                <input type="file" accept="image/*" class="form-control" id="newChallengeMiniInput" (change)="newChallengeMiniInputChange($event)" formControlName="newChallengeMiniInput">
                            </div>
                        </div-->
                        <!--div class="mb-3">
                            <label>Image (fullscreen size)</label>
                            <div>
                                <input type="file" accept="image/*" class="form-control" id="newChallengeFileInput" (change)="newChallengeFileInputChange($event)" formControlName="newChallengeFileInput">
                            </div>
                        </div-->
                    </div>
                </div>
                <div class="mb-3">
                    <button class="btn btn-primary" [disabled]="newChallengeFormGroup.invalid" (click)="uploadNewChallenge()">
                        <i class="fas fa-cloud-upload-alt"></i> Upload
                    </button>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col">
            <div *ngIf="challenges.length > 0">
                <h3>Configure challenges</h3>
                <div *ngFor="let challenge of challenges">
                    <challenge-card [challenge]="challenge" (refreshChallenges)="refreshChallenges()"></challenge-card>
                    <hr>
                </div>
            </div>
        </div>
    </div>
</div>